import { UserAuthenticatedCard, UserUnauthenticatedCard } from '@ui/profile';
import { useUser } from '../../../entites/authorization/use-user.ts';
import { mask } from '@shared/const/mask.ts';

export const UserAuthorizationCard = () => {
  const { isAuthenticated, user } = useUser();

  return (
    <>
      <div className="py-4 lg:pt-0">
        {!isAuthenticated && <UserUnauthenticatedCard />}
        {isAuthenticated && (
          <UserAuthenticatedCard
            name={user?.first_name || 'Ваше имя'}
            phone={user?.phone ? mask(user.phone) : ''}
          />
        )}
      </div>

      <div className="bg-[#F8F9FA] h-2 -mx-4 lg:hidden" />
    </>
  );
};
